"use strict";

var React = require('react');

var _require = require('react-helmet'),
    Helmet = _require.Helmet;

var isExcluded = function isExcluded(collection, element) {
  return Array.isArray(collection) && collection.includes(element.replace(/\/+$/, ''));
};

module.exports = function (_ref, pluginOptions) {
  var element = _ref.element,
      props = _ref.props;

  if (pluginOptions && pluginOptions.siteUrl && !isExcluded(pluginOptions.exclude, props.location.pathname)) {
    var pathname = props.location.pathname || '/';
    if (pluginOptions.noTrailingSlash && pathname.endsWith('/')) pathname = pathname.substring(0, pathname.length - 1);
    var myUrl = "" + pluginOptions.siteUrl + pathname + props.location.search + props.location.hash;
    return React.createElement(React.Fragment, null, React.createElement(Helmet, {
      link: [{
        rel: 'canonical',
        key: myUrl,
        href: myUrl
      }]
    }), element);
  }

  return element;
};